export const FETCH_COTTAGES_REQUEST = 'FETCH_COTTAGES_REQUEST';
export const FETCH_COTTAGES_SUCCESS = 'FETCH_COTTAGES_SUCCESS';
export const FETCH_COTTAGES_FAILURE = 'FETCH_COTTAGES_FAILURE';

export const FETCH_STATS_REQUEST = 'FETCH_STATS_REQUEST';
export const FETCH_STATS_SUCCESS = 'FETCH_STATS_SUCCESS';
export const FETCH_STATS_FAILURE = 'FETCH_STATS_FAILURE';

export const UPDATE_COTTAGES_DATA = 'UPDATE_COTTAGES_DATA';

export const FETCH_COTTAGES_TAGS_REQUEST = 'FETCH_COTTAGES_TAGS_REQUEST';
export const FETCH_COTTAGES_TAGS_SUCCESS = 'FETCH_COTTAGES_TAGS_SUCCESS';
